import { useEffect } from 'react';
import { message } from 'antd';
import { UIMessage } from '../utils/notifications';

export function MessageDisplayer() {
  useEffect(() => {
    const subscription = UIMessage.subscribe(({ type, data }) => {
      const { message: content, messageOptions: options } = data;

      if (message[type]) {
        return message[type]({ ...options, content });
      }
      return message.info({ content });
    });

    return () => subscription.unsubscribe();
  }, []);

  return null;
}
